module.exports = __webpack_public_path__ + "assets/img/TrendingNow_reward.878cbed4-ps.jpg";